import { Node, mergeAttributes } from "@tiptap/core";

const IFRAME_ATTRS = {
  title: "Video",
  loading: "lazy",
  allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
  allowfullscreen: "true",
};

// Block node storing a video player as <div class="video-embed"><iframe src=…></iframe></div>,
// matching the markup the public article renderer styles.
export const VideoEmbed = Node.create({
  name: "videoEmbed",
  group: "block",
  atom: true,
  draggable: true,

  addAttributes() {
    return { src: { default: null } };
  },

  parseHTML() {
    return [
      {
        tag: "div.video-embed",
        getAttrs: (el) => {
          const src = el.querySelector("iframe")?.getAttribute("src");
          return src ? { src } : false;
        },
      },
      {
        tag: "iframe[src]",
        getAttrs: (el) => ({ src: el.getAttribute("src") }),
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      { class: "video-embed" },
      ["iframe", mergeAttributes(IFRAME_ATTRS, { src: HTMLAttributes.src })],
    ];
  },

  addCommands() {
    return {
      setVideoEmbed:
        (src) =>
        ({ commands }) =>
          commands.insertContent({ type: this.name, attrs: { src } }),
    };
  },
});
